import React, { useEffect, useState } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Upload,
  Select,
  message,
  Space,
  Switch,
  Popconfirm,
  Row,
  Col,
  Card,
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  EyeOutlined,
  UploadOutlined,
  SearchOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import api from '../../../api/axios';
import * as XLSX from 'xlsx';
import JSZip from "jszip";
const { Option } = Select;
const toBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      // ❗ only take the raw base64, not the prefix
      const base64Data = reader.result.split(',')[1];
      resolve(base64Data);
    };
    reader.onerror = (error) => reject(error);
  });
};


const AddSparepart = () => {
  const [spareparts, setSpareparts] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [loading, setLoading] = useState(false);
  const [isImageModalVisible, setIsImageModalVisible] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedPartName, setSelectedPartName] = useState('');

  const [bulkModal, setBulkModal] = useState(false);
const [excelData, setExcelData] = useState([]);
const [zipImages, setZipImages] = useState({});
const [previewData, setPreviewData] = useState([]);
const [loadingBulk, setLoadingBulk] = useState(false);

  // ======================== FETCH ========================
  const fetchSpareparts = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/spareparts');
      setSpareparts(res.data);
      setFiltered(res.data);
    } catch (error) {
      console.error(error);
      messageApi.error('Failed to fetch spareparts');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSpareparts();
  }, []);

  const handleExcelRead = async (file) => {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data);
  const sheet = workbook.Sheets[workbook.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(sheet);

  setExcelData(rows);
  generatePreview(rows, zipImages);

  return false; // prevent auto-upload
};
const generatePreview = (excelRows, zipFiles) => {
  if (!excelRows || !zipFiles) return;

  const preview = excelRows.map((row) => {
    const cleanName =
      row.imageFilename?.trim().replace(/\s+/g, '').toLowerCase();

    return {
      importerId: row.importerId,
      imageFilename: row.imageFilename,
      image: zipFiles[cleanName] || null, // NOW WORKS
    };
  });

  setPreviewData(preview);
};


  // ======================== ADD / EDIT ======================== 
 const handleSave = async (values) => {
  try {
    // New uploaded image
    let base64Image = null;
    if (values.photo && values.photo.file) {
      base64Image = await toBase64(values.photo.file); // raw base64, no prefix
    }
  
    const payload = {
      partName: values.partName,
      partNumber: values.partNumber,
      importerId: values.importerId,
      price: values.price || 0,
      measureUnit: values.measureUnit || '',
      isActive: values.isActive !== undefined ? values.isActive : true,
      // ✅ Only send new image OR null (backend keeps existing if null)
      spareImage: base64Image ?? null,
    };

    if (editingItem) {
      await api.put(`/api/spareparts/${editingItem.id}`, payload);
      messageApi.success('Sparepart updated successfully!');
    } else {
      await api.post('/api/spareparts', payload);
      messageApi.success('Sparepart added successfully!');
    }

    await fetchSpareparts();
    setIsModalVisible(false);
    form.resetFields();
    setEditingItem(null);
  } catch (error) {
    console.error(error);
    messageApi.error('Failed to save sparepart');
  }
};


  // ======================== DELETE ========================
  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/spareparts/${id}`);
      const updated = spareparts.filter((sp) => sp.id !== id);
      setSpareparts(updated);
      setFiltered(updated);
      messageApi.success('Sparepart deleted successfully!');
    } catch (error) {
      console.error(error);
      messageApi.error('Failed to delete sparepart');
    }
  };

  // ======================== SEARCH ========================
  const handleSearch = (value) => {
    const searchValue = value.toLowerCase();
    const filteredData = spareparts.filter(
      (item) =>
        item.partName?.toLowerCase().includes(searchValue) ||
        item.partNumber?.toLowerCase().includes(searchValue) ||
        item.importerId?.toLowerCase().includes(searchValue)
    );
    setFiltered(filteredData);
  };

  // ======================== VIEW IMAGE ========================
  const showViewPhoto = async (record) => {
    setSelectedPartName(record.partName); // Set title immediately
    setSelectedImage(null); // Clear previous image
    setIsImageModalVisible(true); // Open modal

    try {
      const res = await api.get(`/api/spareparts/${record.id}/image`);
      if (res.data && res.data.spareImage) {
        const imageSrc = `data:image/jpeg;base64,${res.data.spareImage}`;
     console.log('Base64 first 10 chars:', res.data.spareImage.substring(0, 10));
 
        setSelectedImage(imageSrc);
      } else {
        messageApi.warning('No image found for this sparepart');
      }
    } catch (error) {
      messageApi.error('Error fetching sparepart image');
    }
  };
const handleZipRead = async (file) => {
  const zip = new JSZip();
  const loaded = await zip.loadAsync(file);

  const images = {};

  for (const filename of Object.keys(loaded.files)) {
    const fileObj = loaded.files[filename];

    if (!fileObj.dir) {
      const blob = await fileObj.async("blob");

      const base64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () =>
          resolve(reader.result.split(",")[1]); // raw base64 only
        reader.readAsDataURL(blob);
      });

      // clean filename
      const cleanName = filename.split("/").pop().trim().toLowerCase();

      images[cleanName] = base64;
    }
  }

  setZipImages(images);
  generatePreview(excelData, images);

  return false;
};

const base64ToBlob = (base64, mime = "image/jpeg") => {
  const cleanBase64 = base64.replace(/^data:.+;base64,/, "");
  const byteString = atob(cleanBase64);
  const byteArray = new Uint8Array(byteString.length);

  for (let i = 0; i < byteString.length; i++) {
    byteArray[i] = byteString.charCodeAt(i);
  }

  return new Blob([byteArray], { type: mime });
};

const handleBulkSubmit = async () => {
  try {
    setLoadingBulk(true);

    const formData = new FormData();

    for (const item of previewData) {
      if (item.image) {
        const blob = base64ToBlob(item.image, "image/jpeg");

        formData.append("images", blob, item.imageFilename);
        formData.append("importerIds", item.importerId);
      }
    }

    await api.post("/api/spareparts/bulk-image-upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    message.success("Bulk images uploaded successfully!");
    setBulkModal(false);
    fetchSpareparts();
  } catch (err) {
    console.error(err);
    message.error("Bulk upload failed.");
  } finally {
    setLoadingBulk(false);
  }
};


  // ======================== EXCEL UPLOAD ========================
  const handleExcelUpload = async (file) => {
    const successes = [];
    const failures = [];

    try {
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const rows = XLSX.utils.sheet_to_json(worksheet);

      for (const row of rows) {
        try {
          // Try to add each sparepart
          await api.post('/api/spareparts', row);
          successes.push(row);
        } catch (error) {
          failures.push({ ...row, error: error.response?.data?.message || error.message });
        }
      }

      // After processing, show the report
      if (successes.length > 0) {
        message.success(`${successes.length} spareparts added successfully!`);
      }

      if (failures.length > 0) {
        const failureMessages = failures.map(failure => `Part Number: ${failure.partNumber} - ${failure.error}`).join('\n');
        message.error(`Failed to add ${failures.length} spareparts:\n${failureMessages}`);
      }

      // Refresh spareparts after upload
      fetchSpareparts();
    } catch (error) {
      console.error('Failed to process Excel:', error);
      message.error('Error processing the Excel file');
    }
    return false; // Prevent the default upload behavior
  };

  // ======================== TABLE COLUMNS ========================
  const columns = [
    { title: 'ID', dataIndex: 'importerId', key: 'importerId' },
    { title: 'Part Name', dataIndex: 'partName', key: 'partName' },
    { title: 'Part Number', dataIndex: 'partNumber', key: 'partNumber' },
    { title: 'Unit', dataIndex: 'measureUnit', key: 'measureUnit' },
    { title: 'Price', dataIndex: 'price', key: 'price' },
    {
      title: 'Active',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (value) => (value ? 'Yes' : 'No'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button icon={<EditOutlined />} onClick={() => showEditModal(record)} />
          <Button icon={<EyeOutlined />} onClick={() => showViewPhoto(record)} />
          <Popconfirm
            title="Delete this sparepart?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // ======================== EDIT MODAL ========================
  const showAddModal = () => {
    setEditingItem(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const showEditModal = (record) => {
    setEditingItem(record);
    form.setFieldsValue(record);
    setIsModalVisible(true);
  };

  return (
    <div>
      {contextHolder}
      <Card
        title="Spareparts Management"
        style={{
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
          borderRadius: 8,
          marginBottom: 20,
        }}
        extra={
          <Input.Search
            placeholder="Search Part Name, Number, Id"
            allowClear
            enterButton={<SearchOutlined />}
            onSearch={handleSearch}
            style={{ width: 300 }}
          />
        }
      >
        <Space style={{ marginBottom: 16, flexWrap: 'wrap' }}>
          <Button type="primary" icon={<PlusOutlined />} onClick={showAddModal}>
            Add Sparepart
          </Button>

          {/* EXCEL UPLOAD */}
          <Upload
            beforeUpload={handleExcelUpload}
            accept=".xlsx,.xls"
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>Upload Excel</Button>
          </Upload>
          <Button icon={<UploadOutlined />} onClick={() => setBulkModal(true)}>
  Bulk Image Upload
</Button>

        </Space>

        <Table
          dataSource={filtered}
          columns={columns}
          rowKey="id"
          pagination={{ pageSize: 6 }}
          bordered
          loading={loading}
          scroll={{ x: 'max-content' }}
        />
      </Card>

      {/* ADD / EDIT FORM MODAL */}
      <Modal
        title={editingItem ? 'Edit Sparepart' : 'Add Sparepart'}
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => form.submit()}
      >
        <Form form={form} layout="vertical" onFinish={handleSave}>
          <Row gutter={[12, 12]}>
            <Col xs={24} sm={12}>
              <Form.Item
                name="partName"
                label="Part Name"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Part Name" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="partNumber"
                label="Part Number"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Part Number" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="importerId"
                label="Importer ID"
                rules={[{ required: true }]}
              >
                <Input placeholder="Enter Importer ID" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name="price" label="Price">
                <Input type="number" placeholder="0" />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item
                name="measureUnit"
                label="Measure Unit"
                rules={[{ required: true }]}
              >
                <Select placeholder="Select Unit">
                  <Option value="pcs">pcs</Option>
                  <Option value="set">set</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} sm={12}>
              <Form.Item name="isActive" label="Active" valuePropName="checked">
                <Switch defaultChecked />
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item name="photo" label="Sparepart Image">
                <Upload
                  beforeUpload={(file) => {
                    form.setFieldsValue({ photo: { file } });
                    return false;
                  }}
                  showUploadList={false}
                >
                  <Button icon={<UploadOutlined />}>Upload Image</Button>
                </Upload>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>

      {/* VIEW IMAGE MODAL */}
      <Modal
        open={isImageModalVisible}
        title={selectedPartName || 'Sparepart Image'}
        footer={null}
        onCancel={() => setIsImageModalVisible(false)}
        centered
      >
        {selectedImage ? (
          <img
            src={selectedImage}
            alt={selectedPartName}
            style={{
              width: '100%',
              borderRadius: 8,
              objectFit: 'contain',
              maxHeight: '70vh',
            }}
          />
        ) : (
          <p style={{ textAlign: 'center', color: '#888' }}>
            Loading image or no image available...
          </p>
        )}
      </Modal>
      <Modal
  title="Bulk Sparepart Image Upload"
  open={bulkModal}
  onCancel={() => setBulkModal(false)}
  onOk={handleBulkSubmit}
  okButtonProps={{ disabled: previewData.length === 0 }}
  confirmLoading={loadingBulk}
  width={700}
>
  <p>Upload Excel with importerId + imageFilename, and a ZIP containing the images.</p>

  <Upload beforeUpload={handleExcelRead} accept=".xlsx,.xls" showUploadList={true}>
    <Button icon={<UploadOutlined />}>Upload Excel</Button>
  </Upload>

  <br /><br />

  <Upload beforeUpload={handleZipRead} accept=".zip" showUploadList={true}>
    <Button icon={<UploadOutlined />}>Upload ZIP</Button>
  </Upload>

  {/* Preview Table */}
  <Table
    dataSource={previewData}
    columns={[
      { title: "Importer ID", dataIndex: "importerId" },
      { title: "Image File", dataIndex: "imageFilename" },
      {
  title: "Preview",
  dataIndex: "image",
  render: (img) =>
    img ? (
      <img 
        src={`data:image/jpeg;base64,${img}`} 
        style={{ width: 60, height: 60, objectFit: "contain" }} 
      />
    ) : (
      <span style={{ color: "red" }}>Not Found</span>
    ),
}

    ]}
    rowKey="importerId"
    pagination={false}
    style={{ marginTop: 20 }}
  />
</Modal>

    </div>
  );
};

export default AddSparepart;
